import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  // https://router.vuejs.org/api/v3/interfaces/routeroptions.html#routes
  routes: (_routes) => {}
}
